<template>
  <div class="col-xl-4">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title mb-0">Detalle</h4>
        <div class="card-options">
          <a
            class="card-options-collapse"
            href="javascript:void(0)"
            data-bs-toggle="card-collapse"
            ><i class="fe fe-chevron-up"></i></a
          ><a
            class="card-options-remove"
            href="javascript:void(0)"
            data-bs-toggle="card-remove"
            ><i class="fe fe-x"></i
          ></a>
        </div>
      </div>
      <div class="card-body">
        <div class="container mt-4">
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-4 bg-light text-dark py-2">Evento</div>
                <div class="col-8 bg-white text-dark py-2">
                  {{ info.title }}
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-4 bg-light text-dark py-2">Fecha Inicio</div>
                <div class="col-8 bg-white text-dark py-2">
                  {{ formatTimestampToDate(info.init_date) }}
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-4 bg-light text-dark py-2">Fecha Fin</div>
                <div class="col-8 bg-white text-dark py-2">
                  {{ formatTimestampToDate(info.end_date) }}
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-4 bg-light text-dark py-2">Tipo Evento</div>
                <div class="col-8 bg-white text-dark py-2">
                  {{ info.tipo }}
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="info.tipo != 'Virtual'">
              <div class="row">
                <div class="col-4 bg-light text-dark py-2">Lugar Evento</div>
                <div class="col-8 bg-white text-dark py-2">
                  {{ info.lugar }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({ info: Object });

function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
